import React, { useEffect, useState } from "react";
import { Button, FormControl, FormHelperText, Input, InputLabel, Modal, Box, Snackbar, Alert } from '@mui/material';
import ReactCrop, { Crop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import SpecialBtn from '../Mint/SpecialBtn';
import CropIcon from '@mui/icons-material/Crop';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

//
interface ICropModalProps {
    src: string;
    open: boolean;
    onClose: Function;
    afterCropDone: Function;
    className?: any
}

//
function CropModal(props: ICropModalProps) {

    // State
    const [crop, setCrop] = useState<Crop>();
    const [previewSrc, setPreviewSrc] = useState("");
    const [cropedImgFile, setCropedImgFile] = useState<File | null>(null);

    //
    async function cropImageLoadedHandler(e: any) {
        let img = document.getElementById("crop-image") as HTMLImageElement;

        // We want to keep 1 to 1 aspect radio even if image is not rectengular!
        let widthHeight = img.width;

        if (img.height < img.width) {
            widthHeight = img.height
        }

        setCrop({
            unit: "px",
            x: img.width / 4,
            y: img.height / 4,
            width: img.height / 2,
            height: img.height / 2
        })

        await getCropedImg();
    }

    //
    async function onComplete(e: any, a: any) {
        await getCropedImg();
    }

    //
    async function getCropedImg() {
        if (crop) {
            let img = document.getElementById("crop-image") as HTMLImageElement;
            let cropRes: any = await getCroppedImage(img, crop);

            setPreviewSrc(cropRes.url as string);
            setCropedImgFile(cropRes.file);
        }
    }

    //
    async function getCroppedImage(sourceImage: HTMLImageElement, cropConfig: Crop) {
        // creating the cropped image from the source image
        const canvas = document.createElement("canvas");
        const scaleX = sourceImage.naturalWidth / sourceImage.width;
        const scaleY = sourceImage.naturalHeight / sourceImage.height;
        canvas.width = 200;
        canvas.height = 200;

        const ctx = canvas.getContext("2d");

        if (ctx) {
            ctx.drawImage(
                sourceImage,
                cropConfig.x * scaleX,
                cropConfig.y * scaleY,
                cropConfig.width * scaleX,
                cropConfig.height * scaleY,
                0,
                0,
                200,
                200,
            );
        }

        //
        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                // returning an error
                if (!blob) {
                    reject(new Error("Canvas is empty"));
                    return;
                }

                // creating a Object URL representing the Blob object given
                //const croppedImageUrl = window.URL.createObjectURL(blob);

                var dataURL = canvas.toDataURL("image/png");
                let file = new File([blob], "fileName.png", { type: "image/png" });

                resolve({
                    url: dataURL,
                    file
                });
            }, "image/png");
        });
    }

    //
    function cropBthHanlder() {
        props.afterCropDone(cropedImgFile);
    }

    //
    function closeBthHanlder() {
        props.onClose();
    }

    //
    function onModalClick(e: any) {
        e.preventDefault();
        e.stopPropagation();
    }

    //
    return (
        <Modal
            onClick={onModalClick}
            open={props.open}
            onClose={() => props.onClose()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">

            <Box className={props.className}>
                <Box className="crop-modal-main-cont">
                    <Box className="crop-modal-inner">
                        <Box className="crop-modal-header">
                            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", }}><CropIcon sx={{ fontSize: "26px", marginRight: "5px" }} /> Crop image</Box>
                            <CloseIcon onClick={closeBthHanlder} sx={{ fontSize: "26px", cursor: "pointer", color: "#decdcd" }} />
                        </Box>

                        <Box className="crop-modal-body">
                            <Box id="test" sx={{ border: "1px solid #5d4430", lineHeight: 0 }}>
                                <ReactCrop crop={crop} onChange={c => setCrop(c)} onComplete={onComplete} aspect={1} keepSelection={true}>
                                    <img style={{ width: "100%", maxWidth: "700px" }} onLoad={cropImageLoadedHandler} id="crop-image" src={props.src} />
                                </ReactCrop>
                            </Box>

                            <Box className="crop-modal-review-cont">
                                <img style={{ marginTop: "5px", width: "200px", height: "200px", border: "1px solid #5d4430" }} src={previewSrc} />
                            </Box>

                        </Box>

                        <Box className="crop-modal-footer">
                            <SpecialBtn
                                variant="blue"
                                textColor="#1b1b1b"
                                label="Upload"
                                width="160px"
                                height="36px"
                                labelSize="18px" i
                                nProg={false}
                                onClick={cropBthHanlder}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}

// Default style!
const styledComp = styled(CropModal)({
    flexDirection: "column",
    display: 'flex',
    padding: "10px",
    alignItems: "center",
    width: "100%",
    height: "100%",
    borderRadius: "3px",
    boxShadow: "24",
    outline: "none",
    overflow: "auto",
    ".crop-modal-main-cont": {
        background: "#452f1cd8",
        marginTop: "70px", maxWidth: "500px",
        boxShadow: "0px 0px 15px black"
    },
    ".crop-modal-inner": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "relative"
    },
    ".crop-modal-header": {
        padding: "10px",
        background: "#8c623bbb",
        width: "100%",
        fontSize: "20px",
        fontWeight: 700,
        color: "#decdcd",
        marginBottom: "10px",
        display: 'flex',
        justifyContent: "space-between",
        alignItems: "center"
    },
    ".crop-modal-footer": {
        padding: "10px",
        background: "#8c623bbb",
        width: "100%",
        fontSize: "20px",
        fontWeight: 700,
        color: "decdcd",
        display: 'flex',
        justifyContent: "center",
        alignItems: "center"
    },
    ".crop-modal-body": {
        padding: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        position: "relative"
    },
    ".crop-modal-review-cont": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: "15px",
        marginBottom: '10px'
    }
});

// Export
export default styledComp;
